import { useAuth } from '@shared/components/AuthProvider';
import { useDesignParams } from '@apps/createWedding/hooks/useDesignParams';

/**
 * Checks if the create wedding page is ready.
 *
 * We need to check if the user is logged in and if the design params are settled.
 *
 * @returns true if the create wedding page is ready, false otherwise.
 */
export const useIsCreateWeddingReady = () => {
  const { isCurrentUserSettled } = useAuth();
  const { settled } = useDesignParams();

  return isCurrentUserSettled && settled;
};
